module.exports = __webpack_public_path__ + "img/2.7b4c7e25.png";